import {useMemo} from "react";
import {Bar} from "recharts";
import {BaseChart, ChartComponent} from "./BaseChart";
import {TimeSeriesDataProps} from "../../../types/timeSeriesDataProps";
import {FieldResult} from "../../../types/domain/fieldResult";
import {useTranslation} from "react-i18next";
import dayjs from "dayjs";

export const PercentVegetationCoverChart: ChartComponent = ({data}) => {
    const {t} = useTranslation();
    const chartData = useMemo(() => data.map(mapFieldResultsToChartData), [data]);

    return (
        <BaseChart
            title={t("insights.charts.percent_vegetation_cover.title")}
            yLabel={t("insights.charts.percent_vegetation_cover.y_label")}
            data={chartData}
            helpPopoverTranslationKey="help.popover.fields.vegetation_cover"
        >
            <Bar
                type="monotone"
                dataKey="vegetationCover"
                name={t("insights.charts.percent_vegetation_cover.bar_name")}
                unit="%"
                yAxisId="left"
                fill="#7FCDBB"
                isAnimationActive={false}
            />
        </BaseChart>
    );
};

const mapFieldResultsToChartData = (r: FieldResult): DataProps => ({
    date: dayjs(r.date).toDate(),
    vegetationCover: [0, r.aggregatedProps.vegetation_cover],
});

export interface DataProps extends TimeSeriesDataProps {
    vegetationCover: number[];
}
